"use strict";
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    result["default"] = mod;
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = __importStar(require("react"));
var styles = __importStar(require("./Nursing.module.css"));
function Footer(props) {
    var page = props.page;
    return (React.createElement("div", { className: styles.footerWrap },
        React.createElement("p", { className: styles.footerLeft }, "IntelliTec College Enrollment Agreement"),
        React.createElement("p", { className: styles.footerRight },
            React.createElement("span", { className: styles.footerDescription }, "Vs. 4.0 1/20/24"),
            " Page",
            React.createElement("span", { className: styles.footerBold }, page),
            " of",
            React.createElement("span", { className: styles.footerBold }, "2"))));
}
exports.Footer = Footer;
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiRm9vdGVyLmpzIiwic291cmNlUm9vdCI6Ii4vIiwic291cmNlcyI6WyJwZGYvZm9ybXMvaW50ZWxsaXRlYy9FbnJvbGxtZW50QWdyZWVtZW50L051cnNpbmcvRm9vdGVyLnRzeCJdLCJuYW1lcyI6W10sIm1hcHBpbmdzIjoiOzs7Ozs7Ozs7QUFBQSwyQ0FBOEI7QUFDOUIsMkRBQThDO0FBRTlDLFNBQWdCLE1BQU0sQ0FBQyxLQUFLO0lBQ2pCLElBQUEsaUJBQUksQ0FBUztJQUVwQixPQUFPLENBQ0gsNkJBQUssU0FBUyxFQUFFLE1BQU0sQ0FBQyxVQUFVO1FBQzdCLDJCQUFHLFNBQVMsRUFBRSxNQUFNLENBQUMsVUFBVSw4Q0FBNkM7UUFDNUUsMkJBQUcsU0FBUyxFQUFFLE1BQU0sQ0FBQyxXQUFXO1lBQzVCLDhCQUFNLFNBQVMsRUFBRSxNQUFNLENBQUMsaUJBQWlCLHNCQUF3Qjs7WUFDakUsOEJBQU0sU0FBUyxFQUFFLE1BQU0sQ0FBQyxVQUFVLElBQUcsSUFBSSxDQUFROztZQUNqRCw4QkFBTSxTQUFTLEVBQUUsTUFBTSxDQUFDLFVBQVUsUUFBVSxDQUM1QyxDQUNGLENBQ1QsQ0FBQTtBQUNMLENBQUM7QUFiRCx3QkFhQyJ9